module.exports = __webpack_public_path__ + "img/177.dcb990e1.jpg";